import { Component } from '@angular/core';

import { ICellEditorParams, JoinAdvancedFilterModel, TextAdvancedFilterModel } from 'ag-grid-enterprise';

import { InputChoicesComponent } from '@camelot/form-input';
import { isNullable } from '@camelot/utils';

import { BaseEditorComponent } from '../base-col';
import type { AsyncEnumCol } from './async-enum-col';

@Component({
  host: { 'data-cid': 'async-enum-editor' },
  imports: [InputChoicesComponent],
  selector: '',
  template: `<cam-input-choices
    [input]="$any(this.input)"
    [standalone]="true"
    [onFocus]="this.focus$"
  ></cam-input-choices>`,
})
export class AsyncEnumEditorComponent extends BaseEditorComponent<
  JoinAdvancedFilterModel | TextAdvancedFilterModel,
  AsyncEnumCol,
  number | string
> {
  override agInit(params: ICellEditorParams) {
    super.agInit(params);

    if (this.input) {
      this._registerSubscription(
        this.input.changeValue$.subscribe(() => {
          setTimeout(() => {
            this.params.api.stopEditing();
            this.params.api.tabToNextCell();
          });
        })
      );
    }
  }

  override getValue() {
    const value = this.input?.value?.[0];

    if (isNullable(value) || value === '') {
      return null;
    }
    return this._col?.hasNumericId ? Number(value) : value;
  }
}
